<script>
    import { factoryStore } from "../store/factories.js";
    import { inputVariableStore } from "../store/inputVariables.js";
    import { outputVariableStore } from "../store/outputVariables.js";

    $: ensureFunctions =
        $factoryStore.currentCalculator &&
        $factoryStore.currentCalculator.variables &&
        makeCalcFunctions();

    $: ensureCalculations = $inputVariableStore & doCalculations(); // This is now called explictly by the factorysettings and productsettings instead

    var calculationTimer = null;
    var disabledCalculations = false;
    export function doCalculations() {
        if (disabledCalculations) return;
        disabledCalculations = true;
        clearTimeout(calculationTimer);
        calculationTimer = setTimeout(() => {
            doCalculationsInternal();
            setTimeout(() => {
                disabledCalculations = false;
            }, 100);
        }, 750);
    }
    function makeCalcFunctions() {
        inputVariableStore.update((n) =>
            Object.assign(n, {
                alternateCurrencyRate:
                    $factoryStore.currentCalculator.alternateCurrencyRate,
            })
        );
        $factoryStore.currentCalculator.variables.forEach((variable) => {
            //Set all the input variables
            //  if (!variable.readOnly) {
            $inputVariableStore[variable.varNameKey] =
                variable.value == 0
                    ? 0
                    : variable.value || getTypedFormulaFromItem(variable);
            //  }

            //Set all the calculated output variable functions
            //We only call eval while initializing the calculator, references to the 'compiled' functions are stored for later use
            if (
                variable.formula &&
                isNaN(variable.formula) &&
                variable.formula.indexOf("$") > -1
            ) {
                var debuggerifapplicable = "";
                // if(variable.varNameKey=='LabourCostMinWage') {
                //     debuggerifapplicable='debugger'
                // }
                variable.formula = variable.formula.replace("=", "");
                variable.formula = variable.formula.replace("%", "/100");
                var cleanFormula = variable.formula
                    .substring(0)
                    .split("$")
                    .join("varList.");
                var code = `
                    (function(varList) 
                    {  

                        var ret=0;
                        try
                        {
                            ${debuggerifapplicable}
                            ret= ${cleanFormula}
                        }
                        catch(s)
                        {
                            s=s+''
                          
                            console.log(s) 
                            console.log('error with  ${variable.varNameKey}')
                          
                            ret=0;
                        } 
                        if(isNaN(ret) || !isFinite(ret))
                        {
                           // console.log('NAN with ${variable.varNameKey}')
                            ret=0
                        }
                        return ret;
                    })`;
                try {
                    var eval2 = eval;
                    variable.func = eval2(code);
                } catch (s) {
                    debugger;
                    alert(
                        "error in calc for var " +
                            variable.varNameKey +
                            "\r\n" +
                            variable.formula +
                            "\r\n" +
                            s
                    );
                    variable.func = eval2(
                        `(function(varList) {  var ret=0;  return 0;  })`
                    );
                }
                variable.isFunction = true;
            }

            // set all the 'fixed' output variables (e.g. num free days)
            if (variable.formula && !variable.isFunction) {
                $outputVariableStore[variable.varNameKey] =
                    getTypedFormulaFromItem(variable);
            }
        });
    }

    function getTypedFormulaFromItem(item) {
        if (item.dataType != "text") return parseFloat(item.formula) || 0;
        return item.formula;
    }

    const doCalculationsInternal = () => {
        outputVariableStore.update((n) => {
            return Object.assign(n, { ...$inputVariableStore }); // this sets all the input vars on the output object so we have one object to work with
        });
        outputVariableStore.update((n) => {
            return Object.assign(n, {
                ExchangeRate:
                    $factoryStore.currentCalculator.alternateCurrencyRate,
            }); // this sets all the input vars on the output object so we have one object to work with
        });
        inputVariableStore.update((n) => {
            return Object.assign(n, {
                ExchangeRate:
                    $factoryStore.currentCalculator.alternateCurrencyRate,
            }); // this sets all the input vars on the output object so we have one object to work with
        });
        var totalOutputList = $outputVariableStore;
        if (!totalOutputList.scenarioConfiguration) return;
        if (totalOutputList.scenarioConfiguration.calculatedScenarios == null) {
            totalOutputList.scenarioConfiguration.calculatedScenarios = {};
        }
        calculateScenario($outputVariableStore);
        totalOutputList.scenarioConfiguration.calculatedScenarios["base"] =
            Object.assign($outputVariableStore);
        $inputVariableStore.scenarioConfiguration.scenarios.forEach(
            (scenario) => {
                var scenarioVarList = Object.assign({
                    ...$outputVariableStore,
                    ...$inputVariableStore,
                    ...$inputVariableStore.scenarioConfiguration
                        .scenarioVarValues[scenario],
                });
                calculateScenario(scenarioVarList);

                totalOutputList.scenarioConfiguration.calculatedScenarios[
                    scenario
                ] = Object.assign(scenarioVarList);
            }
        );
        outputVariableStore.update((n) => totalOutputList);
        outputVariableStore.update((n) =>
            Object.assign(n, { scenarioConfiguration: n.scenarioConfiguration })
        );
    };

    let myArray = [];
    function calculateScenario(myList) {
        var done = false;
        var loopcnt = 0;
        while (!done && loopcnt < 100) {
            loopcnt++;
            // we loop multiple times through the calculations because if the order is not correct then secondary vars may not be calculated correctly in the earlier round
            // therefore we loop until recalculation makes no changes this is way easier than determining the calculation order, and its still lightning fast
            if ($factoryStore.currentCalculator.variables) {
                var varsChanged = false;
                $factoryStore.currentCalculator.variables
                    .filter((v) => {
                        return v.isFunction;
                    })
                    .forEach((v) => {
                        if (v.varNameKey == "PercentageDeviation") {
                        }
                        // if (v.varNameKey == "EmployerOnAverageperMonth") {
                        //     console.log("-----");
                        //     console.log(
                        //         "LabourRelatedCostTotalActual-" +
                        //             myList.LabourRelatedCostTotalActual
                        //     );
                        //     console.log(
                        //         "LabourCostTotalCalculated-" +
                        //             myList.LabourCostTotalCalculated
                        //     );
                        //     console.log(
                        //         "LabourCostTotalCalculated-" +
                        //             myList.LabourCostTotalCalculated
                        //     );
                        //     console.log(
                        //         "EmployerOnAverageperMonth-" +
                        //             myList.EmployerOnAverageperMonth
                        //     );
                        //     console.log(v.func(myList) || 0);
                        // }
                        if (v.func != null) {
                            var newVal = v.func(myList) || 0;
                            if (isNaN(newVal)) {
                                alert("nan");
                                debugger;
                            } else {
                                if (newVal > 0) {
                                }
                                //else console.log(v.varNameKey + "c:" + newVal);
                            }
                            if (myList[v.varNameKey] != newVal) {
                                myList[v.varNameKey] = newVal;
                                varsChanged = true;
                            }
                        }
                    });
                if (!varsChanged) {
                    done = true;
                }
            } else {
                done = true;
            }
            if (loopcnt > 20) {
                alert("high loopcount?!");
                return;
            }
        }
    }
</script>
